<div *ngIf="toggleElements" [formGroup]="group" [class.form-group]="!group.disabled" class="row display-flex">

  <!-- label if isEdit  -->
  <label *ngIf="(getControlName.enabled || config.presentation === 'filter' || config.presentation === 'detail')
                  || (config.presentation === 'edit' && config.options.labelShowInDetail)"
         for="{{config.label}}" class="control-label" style="white-space: nowrap;"
         [class.col-sm-0]="config.options.longInput"
         [class.col-sm-3]="!config.options.longInput">
    {{config.label | translate:locale.language}}
  </label>

  <div class="parent-container"
       [class.col-sm-12]="config.options.longInput"
       [class.col-sm-9]="!config.options.longInput"
       formGroupName="{{config.controlName[0]}}">

    <!--  normal form  -->
    <div *ngIf="getControlName.enabled && config.presentation === 'edit'" style="width: 100%;">

      <ngx-select  style="width: 100%"
                  [multiple]="true"
                  [items]="datas"
                  formControlName="{{config.controlName[1]}}"
                   optionValueField="{{config.options.value}}"
                   optionTextField="{{config.options.vue}}"
                  [autoClearSearch]="true"
                  placeholder="{{config.placeholder| translate:locale.language}}">
      </ngx-select>

      <!-- errors form -->
      <div >
        <span *ngIf="showWarning" class="icon-warning" >
          <i tooltip="{{ 'WARNING_SELECT_DATA_CHANGE' | translate:locale.language}}"  class="fas fa-exclamation-triangle"></i>
        </span>
        <span *ngIf="group.get([config.controlName[0], config.controlName[1]]).invalid &&
                    !group.get([config.controlName[0], config.controlName[1]]).value" class="icon-mandatory">*</span>
      </div>
    </div>


    <!-- presentation form  -->
    <div *ngIf="getControlName.disabled || config.presentation === 'detail'" style="width:100%;font-weight:bold;overflow: hidden">

<!--      <span  *ngFor="let option of datas" >-->
<!--        <span *ngIf="option[config.options.value]==group.get(config?.controlName)?.value" >{{ option.englishName | translate:locale.language }}</span></span>-->
<!--      {{ group.get(config?.controlName)?.value}}-->
            <span  *ngFor="let option of datas" >
              <span *ngIf="isValueInControl(option[config.options.value], group.get(config?.controlName)?.value)" >
                 {{ option[config.options.vue] }}&nbsp;&nbsp;
              </span>
            </span>
    </div>


  </div>
</div>

<div *ngIf="false">
  <pre>datas{{ group.get(config?.controlName)?.value}}</pre>
  <pre>datas{{ config.options.value}}</pre>
  <pre>datas{{ config.options.vue}}</pre>
    <pre>datas{{ datas | json}}</pre>
<!--  <pre>errors: {{getControlName?.errors}}</pre>-->
<!--  <pre>presentation:{{config.presentation}}</pre>-->
<!--&lt;!&ndash;  <pre>hideIfDisabled:{{config.options.hideIfDisabled}}</pre>&ndash;&gt;-->
<!--  <pre>enabled:{{getControlName.enabled}}</pre>-->
<!--  <pre>option value:{{config.options.value}}</pre>-->
</div>

